import React from "react";
import { Header } from "semantic-ui-react";
import { ZonedDateTime } from "../../../../../components/global_components/ZonedDateTime";

export interface InspectionSummaryCommentProps {
  comment: string;
  completedAt: string;
  firstName: string;
  lastName: string;
}
export default function InspectionSummaryComment({
  comment,
  completedAt,
  firstName,
  lastName,
}: InspectionSummaryCommentProps) {
  return (
    <div className='tw-flex tw-p-0 hover:tw-bg-none'>
      <div className='tw-w-full tw-pl-0'>
        <div className='tw-flex tw-items-center'>
          <Header className='tw-mb-0 tw-text-lg tw-font-semibold'>{`${firstName} ${lastName}`}</Header>
          <div className='tw-mb-1 tw-ml-2 tw-flex tw-text-[#999999]'>
            <div>
              <ZonedDateTime value={completedAt} formatString='MMM d, yyyy h:mm a' />
            </div>
          </div>
        </div>
        <div className='tw-pt-1'>{comment}</div>
      </div>
    </div>
  );
}
